// extracted by mini-css-extract-plugin
export default {"dialog_user_list":"UsersList_dialog_user_list__crDr5","effect":"UsersList_effect__T4hWZ"};